import { faGear } from '@fortawesome/free-solid-svg-icons'
import { Menu, MenuItem } from '../../../components/interactives/dropdown-menu'
import type { UpdateCueCallback } from '../model/callbacks'
import { forwardRef } from 'react'
import type { Cue } from '@rundown-studio/types'
import { CueType } from '@rundown-studio/types'
import { useOptimisticCueSettings } from '../lib/use-optimistic-cue-settings'
import { settingsConfig } from '../model/settings-submenu'
import { cn } from '@/utils'

type CueSettingsSubmenuProps = {
  cue: Cue
  onUpdateCue: UpdateCueCallback
}

export const CueSettingsSubmenu = forwardRef<
  HTMLButtonElement,
  CueSettingsSubmenuProps
>(function CueSettingsSubmenu({ cue, onUpdateCue }, ref) {
  const { optimisticSettings, toggleSetting } = useOptimisticCueSettings(
    cue?.settings,
    onUpdateCue,
  )

  return (
    <Menu
      ref={ref}
      icon={faGear}
      label="Settings"
      className={cn(
        cue.type === CueType.HEADING &&
          'bg-black opacity-40 pointer-events-none',
      )}
    >
      {settingsConfig.map(({ key, label }) => (
        <MenuItem
          key={key}
          IconComponent={
            <div className="flex items-center">
              <input
                type="checkbox"
                checked={optimisticSettings?.[key]}
                readOnly
              />
            </div>
          }
          label={label}
          onClick={() => toggleSetting(key)}
        />
      ))}
    </Menu>
  )
})
